import Cookies from 'js-cookie';
import {
  Button,
  Typography,
} from '@rrexpress/core';

import { BaseShow } from '@/components/show';
import useLayout from '@/hooks/useLayout';
import { useModal } from '@/hooks/useModal';
import useUser from '@/modules/user/application/user';

import FormPersonalData from './form-personal-data';
// import FormResetPassword from './form-reset-password';

const Profile = () => {
  const { open, close } = useModal();
  const { userId } = JSON.parse(Cookies.get('user_login') as string);
  const { getUserById } = useUser();

  const { data, isLoading, refetch } = getUserById(userId);

  const user: IUser = (data?.data || {}) as IUser;

  useLayout({ title: 'Profile' });

  return (
    <div className="w-[40vw] m-auto">
      <BaseShow
        title={user.full_name || 'Profile'}
        hasBack={false}
        isLoading={isLoading}
      >
        <div>
          <div className="mb-3 flex gap-3 text-left items-end">
            <div className="w-1/3">
              <Typography level={6}>Nama Depan</Typography>
            </div>
            <Typography level={6} fontWeight="medium">{user.first_name}</Typography>
          </div>

          <div className="mb-3 flex gap-3 text-left items-end">
            <div className="w-1/3">
              <Typography level={6}>Nama Belakang</Typography>
            </div>
            <Typography level={6} fontWeight="medium">{user.last_name}</Typography>
          </div>

          <div className="mb-3 flex gap-3 text-left items-end">
            <div className="w-1/3">
              <Typography level={6}>Email</Typography>
            </div>
            <Typography level={6} fontWeight="medium">{user.email}</Typography>
          </div>

          <div className="mb-3 flex gap-3 text-left items-end">
            <div className="w-1/3">
              <Typography level={6}>No telp.</Typography>
            </div>
            <Typography level={6} fontWeight="medium">{user.phone_number || '-'}</Typography>
          </div>

          <div className="mb-3 flex gap-3 text-left items-end">
            <div className="w-1/3">
              <Typography level={6}>Cabang</Typography>
            </div>
            <Typography level={6} fontWeight="medium">{user.branch_name || '-'}</Typography>
          </div>

          <div className="mb-3 flex gap-3 text-left items-end">
            <div className="w-1/3">
              <Typography level={6}>Role</Typography>
            </div>
            <Typography level={6} fontWeight="medium">{user.role_name}</Typography>
          </div>
        </div>
      </BaseShow>

      <div className="flex gap-2 justify-end pt-5">
        <Button
          variant="tertiary"
          onClick={() => open({
            title: 'Ubah Data Diri',
            template: <FormPersonalData data={user} onSuccess={() => refetch()} />,
            onClose: close,
          })}
        >
          Ubah Data Diri
        </Button>
        {/* <Button
          variant="tertiary"
          onClick={() => open({
            title: 'Ganti Password',
            template: <FormResetPassword />,
            onClose: close,
          })}
        >
          Ganti Password
        </Button> */}
      </div>
    </div>
  );
};

export default Profile;
